import type { ReactNode } from "react";
import BackendFormSectionTitle from "./backend-form-section-title";

type BackendFormSectionCardPropsT = {
  title?: string;
  children: ReactNode;
  className?: string;
};

export function BackendFormSectionCard({
  title,
  children,
  className = "",
}: BackendFormSectionCardPropsT) {
  return (
    <section
      className={`rounded-[24px] border border-black/5 bg-white p-5 shadow-[0_18px_45px_rgba(15,23,42,0.06)] md:p-6 ${className}`}
    >
      {title ? <BackendFormSectionTitle title={title} /> : null}
      <div className={`${title ? "mt-5" : ""} space-y-5`}>{children}</div>
    </section>
  );
}
